import React from "react";
import { Button } from "react-bootstrap";
import "./Landing.css";
import Cardcomponent from "./Cardcomponent";
import Jumping from "./Jumping";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClipboardList, faDollarSign, faFaceSmile } from "@fortawesome/free-solid-svg-icons";
import {LANDING_IMAGE} from "../../utils/constants";
const Landing = () => {
  const navigate = useNavigate();
  return (
    <>
      <div>
        {/* first section */}
        <div className='hero-container'>
          <div className='hero-content'>
            <div className='hero-text'>
              <h1>
                Show off products.
                <br />
                Get paid.
              </h1>
              <p className='subtitle'>
                Purebrand lets customers show off products they love. When the
                business makes a sale, you get paid for helping!
              </p>
              <div className='hero-buttons'>
                <button
                  className='btn primary'
                  onClick={() => navigate("/signup")}
                >
                  Sign Up Today
                </button>
                <button
                  className='btn link'
                  onClick={() => {
                    const section = document.getElementById("why-purebrand");
                    section?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  Why Purebrand? <span>→</span>
                </button>
              </div>
              <ul className='benefits'>
                <li>
                  <FontAwesomeIcon icon={faCheck} color='#9194E7' /> Video meeting
                  products you own
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheck} color='#9194E7' /> Get paid for every meeting
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheck} color='#9194E7' /> Earn from every sale
                </li>
              </ul>
            </div>
            <div className='hero-image'>
              <img src={LANDING_IMAGE.LANDING_FIRST_IMAGE} alt='product-preview' />
            </div>
          </div>
        </div>

        {/* Second section */}
        <div className='demo-section' id="why-purebrand">
          {/* Full-width header */}
          <div className='demo-subtitle-container'>
            <h6 className='demo-subtitle'>WHY USE PUREBRAND</h6>
          </div>
          <div className='demo-header'>
            <h2>Video meeting products you love & get paid</h2>
            <p className='subtitle'>
              Purebrand lets customers show off products they love. When the
              business makes a sale, you get paid for helping!
            </p>
          </div>

          {/* Two-column layout below */}
          <div className='demo-grid'>
            {/* Left side image */}
            <div className='demo-image'>
              <img src={LANDING_IMAGE.LANDING_SECOND_IMAGE} alt='woman holding phone' />
            </div>

            {/* Right side info cards */}
            <div className='demo-info'>
              <div className='demo-item'>
                <div className='icon-box'>
                  <FontAwesomeIcon icon={faClipboardList} />
                </div>
                <div>
                  <h4>Sign up with your favorite companies</h4>
                  <p>
                    Purebrand works with companies to set up a great
                    relationship between customers and hosts.
                  </p>
                </div>
              </div>

              <div className='demo-item'>
                <div className='icon-box'>
                  <FontAwesomeIcon icon={faFaceSmile} />
                </div>
                <div>
                  <h4>Video meeting products to customers</h4>
                  <p>
                    Meet with potential customers the same way you would talk to
                    a friend, over a video call.
                  </p>
                </div>
              </div>

              <div className='demo-item'>
                <div className='icon-box'>
                  <FontAwesomeIcon icon={faDollarSign} />
                </div>
                <div>
                  <h4>Get paid for each meeting</h4>
                  <p>
                    The store pays you for meetings you take and/or for every
                    sale you help create.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Cardcomponent /> */}

        {/* Fourth section */}
        <div className='marketing-testimonial-section'>
          <div className='testimonial-header'>
            <h6 className='subtitle'>WHAT PEOPLE ARE SAYING ABOUT</h6>
            <h2>Why Purebrand is great for you</h2>
          </div>

          <div className='testimonial-grid'>
            <div className='testimonial-card'>
              <img src={LANDING_IMAGE.LANDING_PAGE_CLYDE_BAKER_IMAGE} alt='Clyde Barker' className='avatar' />
              <p className='quote'>
                Purebrand has been a great way for me to make some extra money
                by showing off products I already own!
              </p>
              <p className='author'>Clyde Barker</p>
            </div>

            <div className='testimonial-card'>
              <img
                src={LANDING_IMAGE.LANDING_PAGE_GRETTA_STANLEY_IMAGE}
                alt='Gretta Stanley'
                className='avatar'
              />
              <p className='quote'>
                Talking with someone who has used the product gave me the
                confidence to buy, and now I get to pay that forward by helping
                others feel just as sure about their purchases.
              </p>
              <p className='author'>Gretta Stanley</p>
            </div>

            <div className='testimonial-card'>
              <img src={LANDING_IMAGE.LANDING_PAGE_KENNEDY_SMITH_IMAGE} alt='Kennedy Smith' className='avatar' />
              <p className='quote'>
                I loved being able to show off how well the product works and
                answer questions in real-time. It's rewarding to know I helped
                someone make a great purchase.
              </p>
              <p className='author'>Kennedy Smith</p>
            </div>
          </div>
        </div>

        {/* Fifth section */}
        <div className='stats-section'>
          <div className='stats-wrapper'>
            {/* Left content */}
            <div className='stats-content'>
              <h2>
                Share Your Product Experience and Help Others Buy with
                Confidence!
              </h2>
              <p>
                Share your experience with potential buyers and earn cash for
                helping them make purchase decisions.
              </p>
              <button
                onClick={() => navigate("/signup")}
                className='signup-btn'
              >
                Sign Up
              </button>
            </div>

            {/* Right image */}
            <div className='stats-image'>
              <img src={LANDING_IMAGE.LANDING_THIRD_IMAGE} alt='Earning stats illustration' />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Landing;
